<template>
    <div class="bannerNode">
        <div class="contentBox">
            <box-border
                :spanShow="false"
                title="总体设计进度"
                :boxStyle="{
                    background: '#fff'
                }"
            >
                <span class="PAVstyle">
                    P: {{ engineeringProgress.otherObj.P }} A: {{ engineeringProgress.otherObj.A }} V: {{ engineeringProgress.otherObj.V }}
                </span>
                <echart-module
                    ref="engineeringProgress"
                    :option="engineeringProgress"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                :spanShow="false"
                title="CPF & Wellpad & IFL 设计进度"
                :boxStyle="{
                    background: '#fff'
                }"
            >
                <span class="PAVstyle">
                    P: {{ CPFengineeringProgress.otherObj.P }} A: {{ CPFengineeringProgress.otherObj.A }} V: {{ CPFengineeringProgress.otherObj.V }}
                </span>
                <echart-module
                    ref="CPFengineeringProgress"
                    :option="CPFengineeringProgress"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                :spanShow="false"
                title="WIS 设计进度"
                :boxStyle="{
                    background: '#fff'
                }"
            >
                <span class="PAVstyle">
                    P: {{ WISengineeringProgress.otherObj.P }} A: {{ WISengineeringProgress.otherObj.A }} V: {{ WISengineeringProgress.otherObj.V }}
                </span>
                <echart-module
                    ref="WISengineeringProgress"
                    :option="WISengineeringProgress"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
            <box-border
                :spanShow="false"
                title="Temporary Camp 设计进度"
                :boxStyle="{
                    background: '#fff'
                }"
            >
                <span class="PAVstyle">
                    P: {{ CampEngineeringProgress.otherObj.P }} A: {{ CampEngineeringProgress.otherObj.A }} V: {{ CampEngineeringProgress.otherObj.V }}
                </span>
                <echart-module
                    ref="CampEngineeringProgress"
                    :option="CampEngineeringProgress"
                    style="height: 100%;width: 100%;"
                ></echart-module>
            </box-border>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'PlanFour',
        data(){
            const obj = {
                textStyle: {
                    color: '#333333'
                },
                dataZoom: [
                    {
                        height: this.fontSizeFn(20),
                        moveHandleSize: 0,
                        bottom: 10,
                        textStyle: {
                            color: '#8392A5'
                        },
                        dataBackground: {
                        areaStyle: {
                            color: '#8392A5'
                        },
                        lineStyle: {
                            opacity: 0.8,
                            color: '#8392A5'
                        }
                        },
                        brushSelect: true
                    }, {
                        type: 'inside',
                        filterMode: 'filter'
                    }
                ],
                grid: {
                    top: '15%',
                    bottom: this.fontSizeFn(35),
                    right: '2%'
                },
                color: [5, 0, 0, 5, 0],
                legend: {
                    top: '0%'
                },
                tooltip: {
                    formatter: function(datas){
                        let html = `${datas[0].axisValue} <br />`;
                        datas.forEach((item, index) => {
                            if(typeof item.value === 'number'){
                                html += (item.marker + item.seriesName + '&nbsp;&nbsp;' + item.value + '<br/>')
                            }
                            if(index == 2){
                                item.data.s7.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>累计偏差&nbsp;&nbsp;${item.data.s7}<br/>`)
                            }else if(index == 4){
                                item.data.s8.replaceAll(/\s/g, '') && (html += `<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FFFFFF;"></span>本周偏差&nbsp;&nbsp;${item.data.s8}<br/>`)
                            }
                        })
                        return html;
                    }
                },
            }
            return {
                engineeringProgress: {
                    otherObj: {
                        P: '',
                        A: '',
                        V: ''
                    },
                    ...obj
                },
                CPFengineeringProgress: {
                    otherObj: {
                        P: '',
                        A: '',
                        V: ''
                    },
                    ...obj
                },
                WISengineeringProgress: {
                    otherObj: {
                        P: '',
                        A: '',
                        V: ''
                    },
                    ...obj
                },
                CampEngineeringProgress: {
                    otherObj: {
                        P: '',
                        A: '',
                        V: ''
                    },
                    ...obj
                }
            }
        },
        mounted() {
            const arr = [
                {
                    stype: 'Project',
                    name: 'engineeringProgress'
                },
                {
                    stype: 'CPF & Wellpad & IFL',
                    name: 'CPFengineeringProgress'
                },
                {
                    stype: 'WIS',
                    name: 'WISengineeringProgress'
                },
                {
                    stype: 'TCP',
                    name: 'CampEngineeringProgress'
                }
            ];
            this.getAllPromise(arr.map(item => {
                return async() => {
                    this.getNewVTos({
                        id: '2c92808f824759e401825c373c810055',
                        stype: item.stype
                    },
                    [
                        ['累计计划', '累计实际', '累计预测', '本周计划', '本周实际'],
                        ['line', 'line', 'line', 'bar', 'bar'],
                        [1, 1, 1, 0, 0]
                    ],
                    this.$refs[item.name].myChart,
                    {
                        name: item.name,
                        hasMoreData: ['s7', 's8'],
                        yAxisLines: 4,
                        startIndex: 2,
                        yMaxArr: [ null, 100 ]
                    },
                    (res) => {
                        const dataIndex = res.s3.findLastIndex(item => item !== ' ');
                        this.$set(this[item.name].otherObj, 'P', res.s2[dataIndex]);
                        this.$set(this[item.name].otherObj, 'A', res.s3[dataIndex]);
                        this.$set(this[item.name].otherObj, 'V', res.s7[dataIndex]);
                    }
                )
                }
            }));

        },
    }
</script>
<style scoped lang="less">
    .PAVstyle{
        color: #333;
    }
    .contentBox{
        height: 100%;
        width: 100%;
        .gridStyle(2, 2, 0.24rem, 0.1rem);
    }
</style>